<template>
  <NuxtLayout
    :is-menu-hidden="page?.is_menu_hidden"
    :is-footer-hidden="page?.is_footer_hidden"
  >
    <div>
      <Breadcrumbs v-if="page?.link_to_all" :links="breadcrumbs" />
      <PersonHeader v-if="page?.person" :person="page.person" />
      <Widgets v-if="page?.widgets" :widgets="page.widgets" without-h1 />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" async setup>
const { t } = useI18n()
const route = useRoute()
const slug = flatten(route.params.slug)
const { data: page, error } = await useAsyncData('personSlug', async () =>
  useApi().publicPagesPeopleRetrieve(slug)
)

const breadcrumbs = computed(() => [
  { title: t('breadcrumbs.people'), to: `/${page.value?.link_to_all}` },
  { title: page.value?.title ?? '' }
])

if (error.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
}

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    'pl-pl': '/osoba/[slug]'
  }
})

const setI18nParams = useSetI18nParams()
setI18nParams({
  'pl-pl': { slug: page?.value?.slug_pl },
  'pl-en': { slug: page?.value?.slug_en }
})

const { meta } = usePrepareSEOHead(page)
useHead({
  title: page.value?.title,
  meta
})
</script>
